// removed by extract-text-webpack-plugin
module.exports = {"button":"ToggleNav__button___2Te9r"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/ToggleNav/ToggleNav.scss
// module id = 945
// module chunks = 0